module["exports"] = [
  "com",
  "ir",
  "info",
  "net",
  "org"
];
